import { render, staticRenderFns } from "./SidebarAddManually.vue?vue&type=template&id=66e9df7a&scoped=true&"
import script from "./SidebarAddManually.vue?vue&type=script&lang=js&"
export * from "./SidebarAddManually.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e9df7a",
  null
  
)

export default component.exports